<template>
    <div 
        class="lightbox-preview-container d-flex flex-column align-items-center hidden"
    >
        <div
            class="flex-grow-1 d-flex flex-column justify-content-center w-100 mb-2"
        >
            <lightbox-preview-focus-image
              :is-loading="isLoading"
              :src="images[activeImageIndex]"
              @click.prevent="onFocusImageClicked"
            />
        </div>
        <lightbox-preview-image-list
            :images="images"
            :is-loading="isLoading"
            @update-active-index="i => activeImageIndex = i"
        />
    </div>
</template>

<script>
import LightboxPreviewFocusImage from './Components/LightboxPreviewFocusImage.vue';
import LightboxPreviewImageList from './Components/LightboxPreviewImageList.vue';

export default {
    components: {
        LightboxPreviewFocusImage,
        LightboxPreviewImageList,
    },

    props: {
        isLoading: { type: Boolean, default: false },
        lightboxId: { type: String, default: 'defaultLightbox' },
        images: { type: Array, required: true },
        initialIndex: { type: Number, default: 0 },
    },

    emits: [
        'lightbox-requested',
    ],

    data() {
        return {
            activeImageIndex: this.initialIndex,
            hidden: true,
            lightbox: null,
        };
    },

    mounted() {
        this.lightbox = document.getElementById(this.lightboxId);

        if (this.images.length < 1) return;
        if (this.activeImageIndex < 0 || this.activeImageIndex > this.images.length - 1) {
            console.error("LightboxPreview: Active image index out of bounds");
        }
    },

    methods: {
        show(index = 0) {
            this.activeImageIndex = index;
            this.hidden = false;
        },
        hide() {
            this.hidden = true;
        },
        onFocusImageClicked() {
            this.$emit('lightbox-requested', this.activeImageIndex);
        }
    }
}
</script>
